var e={name:"rzTitleWithValue",props:{title:{type:String,required:!0},mobileBigValue:Boolean}};export{e as default};
